function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteGradientAquaticSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 29.104166 29.104167",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-267.89582)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.30182102,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-2",
    width: 29.104166,
    height: 29.104166,
    x: 0,
    y: 267.89581,
    rx: 14.552083,
    ry: 14.552083
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#0073cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.2743828,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-0",
    width: 26.458334,
    height: 26.458334,
    x: 1.3229166,
    y: 269.21875,
    rx: 13.229167,
    ry: 13.229167
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-5",
    width: 21.166666,
    height: 21.166666,
    x: 3.96875,
    y: 271.86456,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#4e79a7",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0",
    width: 18.520834,
    height: 18.520834,
    x: 5.2916565,
    y: 273.18747,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.24736783,
      strokeOpacity: 1
    },
    d: "m 17.528645,283.26878 c 0,1.73853 -1.332654,3.14788 -2.976562,3.14788 -1.643907,0 -2.976562,-1.40935 -2.976562,-3.14788 0,-1.73852 2.091979,-5.78181 2.976562,-5.78181 0.884583,0 2.976562,4.04329 2.976562,5.78181 z",
    id: "path4678-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteGradientAquaticSelected);
export default __webpack_public_path__ + "static/media/icon-site-gradient-aquatic-selected.6cb887c0d99f797bd1e8c15d28e8b432.svg";
export { ForwardRef as ReactComponent };